import common from './common' // 公共|组件|首页|个人中心
import header from './header' // 公共|组件|首页|个人中心

export default {
  ...common,
  ...header
}
